import { PropsWithChildren } from "react";
import styles from "./Collapse.module.scss";
import ChevronRight from "@endya-conformite/ui-kit/src/assets/icons/chevron-right.svg?react";

export function CollapseCompact({
  isOpen,
  title,
  onToggle,
  children,
}: PropsWithChildren & {
  isOpen: boolean;
  title: string;
  onToggle: () => void;
}) {
  return (
    <>
      <button
        className={styles.collapseCompactHeader}
        onClick={onToggle}
        type="button"
      >
        <p>{title}</p>
        <ChevronRight
          className={isOpen ? styles.iconOpen : styles.iconClosed}
        />
      </button>
      {isOpen ? <div>{children}</div> : null}
    </>
  );
}
